import { DeleteApproverMeta, DeleteApproverPayload } from 'types/store/DeleteApprover';
import { createAsyncReducer } from 'utils/Redux';

import { deleteApproverActions } from '../actions';

export default createAsyncReducer<DeleteApproverMeta, DeleteApproverPayload>(deleteApproverActions);
